// Modules
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

// CSS
import '_Asset/css/User/Page/develop.css'

// Component
import { KmList } from 'User/Component';
import { Pagination } from 'User/Component';

// API
import { KmListApi } from '_Route/Api';


const APIManualSearch = () => {

  // use Module
  const navigate = useNavigate();
  const params = useParams();
  

  // Search Input Value Setting
  const [searchVal, setSearchVal] = useState(params.key || '');

  const onChangeSearch = useCallback(e => {
    setSearchVal(e.target.value);
  }, []);
  
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    if (searchVal.length < 2) {
      alert("검색어를 두글자 이상 입력해주세요.")
    } else {
      navigate(`/develop/apis-manual/search${searchVal === '' ? '' : '/' + encodeURIComponent(searchVal)}`);
    }
  }


  // 검색 및 페이징 API 호출
  const [searchInfo, setSearchInfo] = useState([]); // Search Result Paging Data
  const [searchRes, setSearchRes] = useState([]); // Search Result Data

  const [createUser, setCreateUser] = useState();
  const [curSpace, setCurSpace] = useState();
  const [curDate, setCurDate] = useState();
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const blockSize = 10;

  useEffect(() => {
    axios.get(KmListApi, {
      params: {
        km_title: params.key === undefined ? '' : params.key,
        km_last_modify_date: curDate, // 마지막 수정 날짜
        km_create_user: createUser, // 검색할 Author
        km_group: curSpace, // 검색할 SPACE
        curPage: curPage, // 현재 페이지
        pageSize: pageSize, // 한 페이지에 보여줄 건 수
        blockSize: blockSize, // 한 페이지에 보여줄 Pagination 블록 건 수
      }
    })
    .then(res => {
      setSearchInfo(res.data.pageInfo);
      setSearchRes(res.data.result);
    })
    .catch(err => {
      console.error("ERROR", err)
    })
  }, [params, curPage, curSpace, curDate])

  
  return (
    <>
      {/* Visual */}
      <div className="visual develop center">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Knowledge Management</h2>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="searchArea areaBox">
            
            <fieldset>
              <legend>KM 메뉴 검색</legend>

              <div className="fieldWrap search">
                {/* <label htmlFor="">Search</label> */}
              
                <div className="field">
                  <div className="inputIco">
                    <input type="text" className="input md round_10 i_rt" placeholder="검색어를 입력해주세요." value={searchVal} onChange={onChangeSearch} onKeyPress={onKeyPress}></input>
                    <i className="icofont-search" onClick={onSearch}></i>
                  </div>
                </div>
              </div>

              <div className="fieldWrap">
                {/* <div className="fieldGroup">
                  <label htmlFor="">작성자</label>
                
                  <div className="field">
                    <input type="text" className="input md round_10" placeholder='Author' onChange={(e) => setCreateUser(e.target.value)} onKeyPress={onKeyPress}></input>
                  </div>
                </div> */}

                <div className="fieldGroup">
                  <label htmlFor="">SPACE</label>
                
                  <div className="field full">
                    <select className="select round_10 md type_1" onChange={(e) => setCurSpace(e.target.value)}>
                      <option value="">전체</option>
                      <option value="1">CS (Customer Center)</option>
                      <option value="2">SFRT (Seyfert)</option>
                    </select>
                  </div>
                </div>

                <div className="fieldGroup">
                  <label htmlFor="">마지막 수정일</label>
                
                  <div className="field full">
                    <select className="select round_10 md type_1" onChange={(e) => setCurDate(e.target.value)}>
                      <option value="">전체</option>
                      <option value="day">최근 24시간</option>
                      <option value="week">최근 1주일</option>
                      <option value="month">최근 1개월</option>
                      <option value="year">최근 1년</option>
                    </select>
                  </div>
                </div>
              </div>
            </fieldset>

          </div>
        </div>

        <div className="section">
          <div className="searchContArea areaBox">
            {
              searchRes.length !== 0 ?
                <div className="kmItemBox">
                  <p className="pagingTxt">Page {curPage} of {searchInfo.pageCount}. Showing {searchInfo.count} results</p>
                  
                  <div className="kmItemCont">
                    {searchRes.map((key, i) => 
                      <KmList key={i} item={key} searchVal={searchVal} />
                    )}
                  </div>

                  <div className="flexBox center">
                    <Pagination
                      type="type_2"
                      size="lg"
                      curPage={curPage}
                      setCurPage={setCurPage}
                      pageSize={pageSize}
                      blockSize={blockSize}
                      startBlock={searchInfo.startBlock}
                      endBlock={searchInfo.endBlock}
                      pageCount={searchInfo.pageCount}
                    />
                  </div>
                </div>
              :
              <div className="kmItemBox">
                <div className="noDataBox">
                  <i className="icofont-warning-alt"></i>
                  <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default APIManualSearch;